import { render, staticRenderFns } from "./inv_in.vue?vue&type=template&id=5bd51c47"
import script from "./inv_in.vue?vue&type=script&lang=js"
export * from "./inv_in.vue?vue&type=script&lang=js"
import style0 from "./inv_in.vue?vue&type=style&index=0&id=5bd51c47&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports